import { defaultIcons } from './consts';
/**
 * Holds the collection of selected predefined icons. Can be extended with more icons by the consumer.
 * When using icons, they will be checked in library before loading them from CDN.
 */
class IconsCache {
    constructor() {
        Object.defineProperty(this, "cache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "add", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (...icons) => {
                icons.forEach(icon => {
                    this.cache.set(icon.name, icon);
                });
            }
        });
        Object.defineProperty(this, "get", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (name) => {
                const icon = this.cache.get(name);
                if (!icon) {
                    /* eslint-disable-next-line no-console */
                    console.error(`Icon ${name} does not exist in the library.`);
                }
                return icon;
            }
        });
        Object.defineProperty(this, "has", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (name) => {
                return this.cache.has(name);
            }
        });
        Object.defineProperty(this, "init", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.add(...Object.values(defaultIcons));
            }
        });
        Object.defineProperty(this, "reset", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.cache.clear();
            }
        });
    }
}
const cache = new IconsCache();
cache.init();
export default cache;
